import { ReactElement } from "react";

import Loading from "~frontend/components/Loading";

export default function Uploading({
  progress,
  filename = null,
}: {
  progress: number;
  filename?: string | null | undefined;
}): ReactElement {
  return (
    <Loading
      progress={progress}
      message={
        <>
          <span>
            Uploading {filename || ""} ({(progress * 100).toFixed(1)}%)...
          </span>
          <br />
          <em>Do not leave this page</em>
        </>
      }
    />
  );
}
